var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('q-layout',{attrs:{"view":"hhr lpR ffr"}},[_c('TheNavbar'),_c('q-page-container',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_c('TheFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }